module.exports = __webpack_public_path__ + "static/ticket_checker_help6-cad66513bd82c4a9e88b94a8213a1644.jpg";